import Vue from 'vue';
import VueLazyLoad from 'vue-lazyload';
import axios from '../../../api/common/axios';

import urlUtil from '../../../util/url';
import reviewApi from '../../../api/review';
import textUtil from '../../../util/text';
import dayjs from 'dayjs';
import avatarIcon from '../../avatar/avatarIcon.vue';

Vue.use(VueLazyLoad);

export default Vue.extend({
  data() {
    return {
      reviews: [],
      reviewGalleries: [],
      reviewPage: 1,
      reviewCount: 15,
      maxStringLength: 700,
      enableLoadMoreReviewsButton: false,
      loading: false
    };
  },
  components: {
    'vue-avatar-icon': avatarIcon
  },
  props: {
    userId: {
      type: String,
      default: ''
    },
    productId: {
      type: String,
      default: ''
    },
    productTitle: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.loadReviews(null, true);
  },
  computed: {
    dummyThumbnail() {
      return urlUtil.cloudImageUrl('/static/shop/product_no_image.png');
    }
  },
  methods: {
    webp: urlUtil.webp,
    isReviewOwner(review) {
      return this.userId === review.user._id.toString();
    },
    showEdited(review) {
      const create = dayjs(review.created_at);
      const update = dayjs(review.posted_at);
      return create.diff(update) < 0;
    },
    dateFormatted(date, format) {
      if (format == null) {
        format = '';
      }
      return dayjs(date).format(format);
    },
    loadReviews(event, isMounted) {
      if (event) {
        event.preventDefault();
      }
      this.loading = true;

      const params = {
        page: this.reviewPage,
        count: this.reviewCount,
        id: this.productId
      };
      if (isMounted) {
        params.photo_galleries = 1;
      }

      axios
        .get('/api/review/get', {
          params
        })
        .then((response) => {
          if (!response.error) {
            const reviews = response.data;
            for (let i = 0; i < reviews.data.length; i++) {
              reviews.data[i].isShowAllText = false;
            }
            this.reviewPage = reviews.page + 1;
            this.reviews = this.reviews.concat(reviews.data);
            if (reviews.galleries) {
              this.reviewGalleries = reviews.galleries;
            }
            this.enableLoadMoreReviewsButton =
              reviews.page_total > reviews.page;
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    imageSrc(review) {
      if (!review || !review.media) {
        return '';
      }
      return window.tom.conf.path.resize_origin + review.media;
    },
    resizedImageSrc(review, thumbnailSize) {
      if (!review || !review.media) {
        return '';
      }
      return tom.helper.filterImageSrc(
        window.tom.conf.path.resize +
          'resize/' +
          thumbnailSize +
          '/' +
          review.media
      );
    },
    feedback(reviewId, helpful) {
      const review = this.reviews.find((r) => {
        return r._id === reviewId;
      });

      if (!review) {
        return;
      }

      reviewApi.feedback(
        {
          id: reviewId,
          helpful: helpful
        },
        (err, res) => {
          if (err || res.status !== 'ok') {
            return;
          }
          review.feedback.positive = res.feedback.positive;
          review.feedback.negative = res.feedback.negative;
          review.feedback_helpful = helpful;
          return (review.feedback_flag = res.isFeedbacked);
        }
      );
      return false;
    },
    truncateAndEscapeToBodyText(text) {
      if (!text) {
        return '';
      }
      const truncatedText = textUtil.truncate(text, this.maxStringLength);
      return textUtil.nl2br(textUtil.escape(truncatedText));
    },
    toggleReadmore(reviewId) {
      const review = this.reviews.find((r) => {
        return r._id === reviewId;
      });

      if (!review) {
        return;
      }
      review.isShowAllText = !review.isShowAllText;
    },
    onDelete(productId, reviewId) {
      if (
        window.confirm(
          'Are you sure you want to permanently delete this Review?'
        )
      ) {
        reviewApi.delete(
          {
            product_id: productId
          },
          (err, res) => {
            if (err || res.status !== 'ok') {
              return;
            }
            this.reviews = this.reviews.filter((r) => {
              r._id !== reviewId;
            });
          }
        );
      }
    },
    onClickPic(modalId) {
      this.$modal.show(modalId);
    },
    closePic(event) {
      const modal = event.target.closest('[data-modal]');
      this.$modal.hide(modal.getAttribute('data-modal'));
    }
  }
});
